module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/fe2ae8e638ecd5de3d5b1a553a5911a5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_back.svg
// module id = 0dCu
// module chunks = 0